export const formatChainIdForTradesilvania = (
  chainId: "multiversx" | "solana"
) => {
  if (chainId === "multiversx") {
    return "egld";
  }
  return "sol";
};
